var _path, _rect, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00041 14.5C1.00041 7.04554 7.05271 1 14.5217 1C21.9907 1 28.043 7.04554 28.043 14.5C28.043 21.9545 21.9907 28 14.5217 28C7.05271 28 1.00041 21.9545 1.00041 14.5Z",
    stroke: "#717070",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.5898,
    y: 9.60156,
    width: 6.6746,
    height: 8.59259,
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3364 13.5906L24.2064 8.99551L29.6117 8.48421L27.3364 13.5906Z",
    fill: "#717070"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2899_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2823 20.2341L13.7681 21.3355L8.25391 20.2341L8.25391 11.1841L13.7681 11.9347L19.2823 11.1841L19.2823 20.2341Z",
    fill: "#FFFAFA",
    stroke: "#717070",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 12.0166L15.6449 13.7167L21.0087 12.6012L19.3569 11.1514L13.7539 12.0166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 12.0166L15.6449 13.7167L21.0087 12.6012L19.3569 11.1514L13.7539 12.0166",
    stroke: "#717070",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32158 11.0146L6.80859 12.7101L11.8018 13.8162L13.8212 12.0436L8.20881 11.0626",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32158 11.0146L6.80859 12.7101L11.8018 13.8162L13.8212 12.0436L8.20881 11.0626",
    stroke: "#717070",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7988 21.3522L13.7539 12.0566",
    stroke: "#717070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34766 10.7411L13.9098 10.2041L19.472 10.7411",
    stroke: "#747272",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2899_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4616,
    height: 16.1111,
    fill: "white",
    transform: "translate(6.67969 5.37061)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProduct);
export default __webpack_public_path__ + "static/media/update-product.a4f31b9ebc9a72138f557e79f8c3d590.svg";
export { ForwardRef as ReactComponent };